<template>
  <b-modal
    id="mfa-input-modal"
    modal-class="mfa-input-modal"
    :visible.sync="showSecondModal"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    @hidden="onClose"
  >
    <template #modal-title>
      <h3>
        <slot name="txtHeadline"></slot>
      </h3>
    </template>
    <p>
      <dyn-slot :slotData="slotData">
        <slot name="txtDescription"></slot>
      </dyn-slot>
    </p>
    <MfaCodeInput @updated="updateCode" :error-message="errorMessage" :error-key="errorKey">
      <template v-for="slot in possibleChildSlotsFor('Code')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </MfaCodeInput>
    <template #modal-footer>
      <b-button variant="secondary" @click="onClose">
        <slot name="btnCancel">Abbrechen</slot>
      </b-button>
      <b-button variant="primary" :disabled="!isCodeValid" @click="onSubmit">
        <slot name="btnSubmit">Absenden</slot>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import MfaCodeInput from '@/components/process/generic/Mfa/MfaCodeInput.vue'
import { mapActions, mapGetters } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import { BModal } from 'bootstrap-vue'

const codeLength = 6

export default {
  name: 'MfaInput',
  components: {
    MfaCodeInput,
    BModal
  },
  data () {
    return {
      code: '',
      isCodeInvalid: false,
      showSecondModal: true,
      errorMessage: '',
      errorKey: 0
    }
  },
  mixins: [
    slotProxy()
  ],
  computed: {
    ...mapGetters('mfa', [
      'getMsisdn'
    ]),
    slotData () {
      return {
        msisdn: this.maskPhoneNumber('+' + this.getMsisdn)
      }
    },
    isCodeValid () {
      return this.code.length === codeLength
    }
  },
  methods: {
    ...mapActions('mfa', [
      'completeMfa'
    ]),
    maskPhoneNumber (phone) {
      const cleanPhone = phone.replace(/\s+/g, '')
      const lastTwo = cleanPhone.slice(-2)

      const match = cleanPhone.match(/^(\+\d{2})(\d+)(\d{4})$/)

      if (match) {
        const prefix = match[1]
        const masked = 'X'.repeat(match[2].length)
        return `${prefix}${masked}${lastTwo}`
      }
      return phone
    },
    updateCode (code) {
      this.code = code
      this.isCodeInvalid = false
    },
    onClose () {
      this.code = ''
      this.errorMessage = ''
      this.$emit('close')
    },
    async onSubmit () {
      if (!this.isCodeValid) {
        this.isCodeInvalid = true
        return
      }

      try {
        await this.completeMfa(this.code)
        this.showSecondModal = false
        this.$emit('completed')
      } catch (error) {
        this.errorKey++
        this.errorMessage = error?.networkError?.result?.errors?.[0]?.message || 'Ein unbekannter Fehler ist aufgetreten.'
      }
    }
  }
}
</script>
